<template>
    <div @mouseover="onOver" @mouseleave="onLeave">
        <b-nav-item-dropdown :ref="reference"  :no-caret="!isMobileLayout" :class="{ 'extended': extended }">
            <template #button-content>
                <template v-if="isMobileLayout">
                    <slot name="button-content"></slot>
                </template>
                <router-link v-else :to="to" @click.prevent="onLeave">
                    <slot name="button-content"></slot>
                </router-link>
            </template>
            <slot></slot>
        </b-nav-item-dropdown>
    </div>
</template>

<script>
export default {
    name: `menu-dropdown`,
    props: {
        to: { type: String, default: `` }
    },
    data() {
        return {
            extended: false
        }
    },
    computed: {
        reference() {
            return `dropdown`;
        }
    },
    methods: {
        onOver() {
            if (!this.isMobileLayout) {
                this.$refs.dropdown.visible = true;
                // setTimeout(() => {
                this.extended = true;
                // }, 50);
            }
        },
        onLeave() {
            if (!this.isMobileLayout) {
                this.extended = false;
                // setTimeout(() => {
                this.$refs[this.reference].visible = false;
                // }, 300);
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.nav-item {
    a {
        color: inherit;
        text-decoration: none !important;
    }

    ::v-deep .dropdown-menu {
        min-width: 180px;
        background: #000;
        backdrop-filter: saturate(180%) blur(20px);
        box-shadow: none;

        .dropdown-item {
            padding: 7px 14px !important;
            font-weight: 500;
            letter-spacing: 1px;
            color: #ccc;

            &:hover {
                background: #222;
                color: white;
            }
        }

        li {
            & + li {
                //border-top: 1px solid rgba(0, 0, 0, 0.1) !important;
            }
        }

        @media(max-width: 992px) {
            .dropdown-item {
                .fal {
                    margin-right: 5px;
                    width: 24px;
                    text-align: center;
                }
            }
        }

        @media(min-width: 992px) {
            width: 416px;
            border: 1px solid #47D6C1;
            padding: 3px;

            &.show {
                display: block;

                &:before {
                    content: "";
                    position: absolute;
                    top: -16px;
                    left: 50px;
                    border: 8px solid transparent;
                    border-bottom-color: #47D6C1;
                }
            }

            li {
                display: inline;
            }

            .dropdown-item {
                text-align: center;
                display: inline-flex;
                flex-direction: column;
                align-items: center;
                width: 130px;
                height: 92px;
                padding: 10px;
                margin: 3px;
                position: relative;
                color: #fff;
                opacity: 0.8;
                transition: opacity 150ms;
                letter-spacing: 1px;
                font-size: 9pt;
                text-decoration: none !important;
                border-radius: 8px;
                overflow: hidden;

                span {
                    display: flex;
                    height: 31px;
                    align-items: center;
                    white-space: initial;
                }

                .fal {
                    width: 50px;
                    height: 38px;
                    object-fit: contain;
                    display: block;
                    font-size: 30px;
                    line-height: 38px;
                    margin-bottom: 5px;
                }
            }
        }
    }
}

/* Animation
.b-nav-dropdown {
    ::v-deep .dropdown-menu {
        opacity: 0;
        transition: opacity 300ms;
    }

    &.extended {
        ::v-deep .dropdown-menu {
            opacity: 1 !important;
        }
    }
}
*/
</style>
